export type ImageOwnerKind = 'tenant' | 'facility' | 'resource'

export interface IImage {
    id:           string
    owner_kind:   ImageOwnerKind
    owner_id:     string
    content_type: string
    size:         number
    sort:         number
}

/** The staff portal's address of an image's bytes — authenticated by the JWT cookie. */
export const imageUrl = (id: string): string => `/api/rezervacije/v1/images/${id}`
